import React from 'react';
import Navbar from '../components/Navbar';
import RecordsList from '../components/RecordsList';

const DataInput: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-1 container max-w-(--breakpoint-lg) mx-auto">
        <div className="bg-white rounded-lg p-3">
          <RecordsList />
        </div>
      </main>
    </div>
  );
};

export default DataInput;
